import { createAsyncThunk } from '@reduxjs/toolkit';

import { IGrpcService } from '@/services/GrpcService';
import injectContainer from '@/services/InjectContainer';
import ServiceTypes from '@/services/ServiceTypes';

import { ReferenceItem, ReferencesParameters } from '../types';

const fetchReferences = createAsyncThunk(
  'references/fetchReferences',
  async (parameters: ReferencesParameters) => {
    const grpcService = injectContainer.get<IGrpcService>(ServiceTypes.Grpc);

    const { referencesClient } = grpcService;

    const response = await referencesClient.get({
      ...parameters,
      references: parameters.references.map(
        ({ collection_id: collectionId, ...rest }) => ({
          ...rest,
          collectionId,
        }),
      ),
    });

    return [...response.items, ...response.notfound] as ReferenceItem[];
  },
);

export default fetchReferences;
